import { createSlice } from '@reduxjs/toolkit';
import { LoginState } from '../../types/api';

const initialState: LoginState = {
  cardDetails: {},
};

export const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    setCardDetails: (state, action) => {
      state.cardDetails = action.payload;
    },
  },
});

export const { setCardDetails } = loginSlice.actions;

export default loginSlice.reducer;
